import { render } from "./PersonalDonationStep3.vue?vue&type=template&id=40ae7bb3"
import script from "./PersonalDonationStep3.vue?vue&type=script&lang=js"
export * from "./PersonalDonationStep3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__